<template>
  <!-- number/money 数字类：maxlength/前后缀（仅 number）+ min/max/precision/step -->
  <a-row :gutter="16">
    <TextAddonConfig
      v-if="TEXT_WITH_ADDON_TYPES.includes(config.type)"
      :config="config"
    />
    <NumberRangeConfig :config="config" />
  </a-row>
</template>

<script setup lang="ts">
import { TEXT_WITH_ADDON_TYPES } from '../constants';
import NumberRangeConfig from '../NumberRangeConfig.vue';
import TextAddonConfig from '../TextAddonConfig.vue';

defineProps<{ config: any }>();
</script>
